import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import selfTeamsAtom from 'screens/Auth/components/InitProvider/selfTeams.atom'
import useSelfActiveProject from 'screens/Projects/hooks/useSelfActiveProject'

const useActiveProjectTeam = () => {
  const teams = useRecoilValue(selfTeamsAtom).items
  const activeProject = useSelfActiveProject()

  return useMemo(() => {
    if (!activeProject) return undefined

    const claimedTeamIds = new Set(activeProject.slots.flatMap((slot) => (slot.claimedBy ? [slot.claimedBy.id] : [])))

    return teams.find((team) => claimedTeamIds.has(team.id))
  }, [activeProject, teams])
}

export default useActiveProjectTeam
